<section
  class="filters-wrap tw-flex tw-flex-column md:tw-flex-row tw-gap-2 tw-w-full tw-flex-wrap block-assignment-input"
  [class.desktop-filters]="(mediaService.isMobileView$ | async) === false">
  <ng-container *ngTemplateOutlet="(mediaService.isMobileView$ | async) ? mobileHeader : desktopHeader"></ng-container>
  <div class="tw-flex tw-flex-column md:tw-flex-row tw-gap-2 tw-w-full">
    <mg-form-text-input
      class="input search-input"
      type="text"
      iconSet="minga"
      iconLeft="mg-search"
      [condensed]="true"
      [id]="'tools-myclass-input-search-name'"
      [attr.aria-label]="MESSAGES.ARIA_LABEL_SEARCH_ALL"
      [loading]="searchingAllStudents"
      [control]="form.get(FORM_FIELDS.SEARCH_TEXT_FILTER)"
      [label]="MESSAGES.FORM_LABEL_TEXT_SEARCH"
      [isClearable]="true"
      [isDisabled]="form.get(FORM_FIELDS.LIST_FILTER).value?.length === 0">
    </mg-form-text-input>
    <div class="tw-flex tw-flex-row tw-w-full">
      <div class="toggles tw-flex tw-flex-row tw-items-center tw-gap-2 tw-w-full">
        <mg-chip
          [disabled]="LOCKED_STATES | includes: formState"
          [id]="'tools-myclass-click-all'"
          [attr.aria-label]="
            totalNumberOfInClassStudents !== 0 && totalNumberOfInClassStudents === selectedNumberOfStudents
              ? MESSAGES.ARIA_LABEL_UNSELECT_ALL
              : MESSAGES.ARIA_LABEL_SELECT_ALL
          "
          [active]="totalNumberOfInClassStudents !== 0 && totalNumberOfInClassStudents === selectedNumberOfStudents"
          [disabled]="totalNumberOfInClassStudents === 0"
          (click)="onToggleSelectAll()">
          {{
            totalNumberOfInClassStudents !== 0 && totalNumberOfInClassStudents === selectedNumberOfStudents
              ? MESSAGES.FORM_LABEL_UNSELECT_ALL
              : MESSAGES.FORM_LABEL_SELECT_ALL
          }}
        </mg-chip>
        <mg-chip
          [ngClass]="{ randomizing: formState === 'randomizing' }"
          [id]="'tools-myclass-click-random'"
          [attr.aria-label]="MESSAGES.ARIA_LABEL_SELECT_RANDOM"
          [disabled]="totalNumberOfInClassStudents === 0 || (LOCKED_STATES | includes: formState)"
          (click)="onSelectRandom()">
          {{
            formState === 'randomizing'
              ? MESSAGES.FORM_LABEL_SELECT_RANDOMIZING
              : (mediaService.isMobileView$ | async)
              ? MESSAGES.FORM_LABEL_SELECT_RANDOM_MOBILE
              : MESSAGES.FORM_LABEL_SELECT_RANDOM_DESKTOP
          }}
        </mg-chip>
      </div>
      <div class="tw-w-full tw-text-right">
        <mg-tt-settings
          class="settings tw-inline-block"
          [form]="form"></mg-tt-settings>
      </div>
    </div>
  </div>
</section>

<ng-template #desktopHeader>
  <div class="tw-w-full tw-flex tw-flex-row tw-items-center tw-gap-2 tw-flex-wrap">
    <mg-user-list-filter
      *ngIf="userListOptions$ | async as userListOptions"
      class="input user-list-input"
      [id]="'tools-myclass-click-filter-list'"
      [attr.aria-label]="MESSAGES.ARIA_LABEL_SELECT_USER_LIST"
      [value]="form.get(FORM_FIELDS.LIST_FILTER).value"
      [placeholder]="MESSAGES.FORM_LABEL_LIST"
      [condensed]="true"
      (selectChanged)="onUserListChange($any($event))"
      [disableWrapping]="true"
      [hideSelected]="true"
      [layout]="(mediaService.isMobileView$ | async) ? 'mobile' : 'desktop'"
      [options]="userListOptions"
      returnMode="full">
    </mg-user-list-filter>
    <ng-container *ngFor="let list of form.get(FORM_FIELDS.LIST_FILTER).value">
      <mg-tag
        size="medium"
        class="pill-tag"
        [iconLeft]="list.category?.icon"
        [iconLeftColor]="list.category?.iconColor">
        <div class="tw-flex tw-shrink-0 tw-items-center">
          <mg-text variant="label-md-secondary">
            {{ list.label }}
          </mg-text>
          <mg-icon
            class="pill-close-btn"
            iconSet="minga"
            iconName="mg-cross"
            (click)="removeFilter(list)">
          </mg-icon>
        </div>
      </mg-tag>
    </ng-container>
  </div>
</ng-template>

<ng-template #mobileHeader>
  <div class="tw-w-full tw-flex tw-flex-row tw-items-center tw-gap-2 tw-flex-wrap">
    <mg-user-list-filter
      *ngIf="userListOptions$ | async as userListOptions"
      class="input user-list-input"
      [id]="'tools-myclass-click-filter-list'"
      [attr.aria-label]="MESSAGES.ARIA_LABEL_SELECT_USER_LIST"
      [value]="form.get(FORM_FIELDS.LIST_FILTER).value"
      [placeholder]="MESSAGES.FORM_LABEL_LIST"
      [condensed]="true"
      (selectChanged)="onUserListChange($any($event))"
      [disableWrapping]="true"
      [hideSelected]="true"
      [layout]="(mediaService.isMobileView$ | async) ? 'mobile' : 'desktop'"
      [options]="userListOptions"
      returnMode="full">
    </mg-user-list-filter>
    <div class="overflow-shadow">
      <div class="mobile-tag-wrap">
        <ng-container *ngFor="let list of form.get(FORM_FIELDS.LIST_FILTER).value">
          <mg-tag
            size="medium"
            class="pill-tag tw-mr-2"
            [iconLeft]="list.category?.icon"
            [iconLeftColor]="list.category?.iconColor">
            <div class="tw-flex tw-shrink-0 tw-items-center">
              <mg-text variant="label-md-secondary">
                {{ list.label }}
              </mg-text>
              <mg-icon
                class="pill-close-btn"
                iconSet="minga"
                iconName="mg-cross"
                [attr.aria-label]="list.label + MESSAGES.ARIA_LABEL_CHANGE_USER_LIST"
                (click)="removeFilter(list)">
              </mg-icon>
            </div>
          </mg-tag>
        </ng-container>
      </div>
    </div>
  </div>
</ng-template>
